import bind from 'autobind-decorator'
import Modernizr from 'modernizr';

const support = {animations: Modernizr.cssanimations},
    animEndEventNames = {
        'WebkitAnimation': 'webkitAnimationEnd',
        'OAnimation': 'oAnimationEnd',
        'msAnimation': 'MSAnimationEnd',
        'animation': 'animationend'
    },
    animEndEventName = animEndEventNames[Modernizr.prefixed('animation')],
    onEndAnimation = function (el, callback) {
        const onEndCallbackFn = function (ev) {
            if (support.animations) {
                if (ev.target != this) return;
                this.removeEventListener(animEndEventName, onEndCallbackFn);
            }
            if (callback && typeof callback === 'function') {
                callback.call();
            }
        };
        if (support.animations) {
            el.addEventListener(animEndEventName, onEndCallbackFn);
        }
        else {
            onEndCallbackFn();
        }
    };

class Dialog {
    constructor(el, options) {
        if (typeof el == "string") {
            //create from text/html
            $("#dialog_template .dialog__content__body").html(el);
            el = $("#dialog_template")[0];
        }
        this.$el = $(el);
        this.options = Object.assign({onOpenDialog: () => (false), onCloseDialog: () => (false)}, options);
        this.open();
    }

    toggle() {
        if (this.isOpen) {
            this.close();
        }
        else {
            this.open();
        }
    }

    get$El() {
        return this.$el;
    }

    @bind
    handleKeyDown(ev) {
        const keyCode = ev.keyCode || ev.which;
        if (keyCode == 27 && this.isOpen) {
            this.toggle();
        }
    }

    @bind
    open() {
        this.isOpen = true;
        // EVENTS
        /**
         * Legacy selector
         */
        this.$el.find("[data-dialog-close]").on('click', this.close);
        /**
         * Current close selector
         */
        this.$el.find('.close_dialog').on('click', this.close);
        this.$el.find('.dialog__overlay').on('click', this.close);
        $(document).on('keydown', this.handleKeyDown);

        this.$el.addClass('dialog--open');
        this.options.onOpenDialog(this);
    }

    @bind
    close(ev) {
        this.isOpen = false;
        // EVENTS
        this.$el.find("[data-dialog-close]").off('click', this.close);
        this.$el.find('.dialog__overlay').off('click', this.close);
        $(document).off('keydown', this.handleKeyDown);

        // ANIMATIONS
        ev && ev.preventDefault && ev.preventDefault();
        this.$el.removeClass('dialog--open').addClass('dialog--close');

        onEndAnimation(this.$el.find('.dialog__content'), () => {
            this.$el.removeClass('dialog--close');
        });
        this.options.onCloseDialog(this);
    }

    @bind
    setBody(html) {
        this.$el.removeClass("is-empty").addClass('visible');
        this.$el.find(".dialog__content__body").html(html);
    }
}

export default Dialog



// WEBPACK FOOTER //
// ./assets/js/dialog.js